// @flow
import mediatorChannels from "@tvg/mediator";
import { get } from "lodash";
import pushToDataLayer from "../gtmUtils";

export default () => {
  mediatorChannels.base.subscribe("FDR_LOGIN_SUCCESS", (data) => {
    const balance = get(data, "payload.userBalance");
    const fixedBalance =
      typeof balance === "number" ? balance.toFixed(2) : undefined;
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "Login Success",
      gaEventLabel: undefined,
      module: "Login",
      microApp: "non-Microapp",
      accountId: get(data, "payload.accountId", ""),
      loginStatus: "Logged In",
      registrationStatus: "Registered",
      balance: fixedBalance
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_REDIRECT_TO_BRAND", (data) => {
    pushToDataLayer({
      event: "navigation",
      gaEventCategory: "Login",
      gaEventAction: "navigated to",
      gaEventLabel: get(data.payload, "buttonText"),
      tag: undefined,
      module: "location services",
      destinationUrl: get(data.payload, "destinationUrl", "")
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_ALLOW_LOCATION", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Login",
      gaEventAction: "Enable Location Services",
      tag: undefined,
      gaEventLabel: "login",
      module: "location services"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_SELECT_STATE_MANUALLY", () => {
    pushToDataLayer({
      event: "navigation",
      gaEventCategory: "Login",
      gaEventAction: "Select State Manually",
      tag: undefined,
      gaEventLabel: "login",
      module: "location services"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_STATE_SELECTED", (data) => {
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "State Selected",
      tag: undefined,
      gaEventLabel: get(data.payload, "selectedState", ""),
      module: "login modal"
    });
  });

  mediatorChannels.base.subscribe("FDR_USER_STARTS_LOGIN", () => {
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "Login Start",
      tag: undefined,
      gaEventLabel: undefined,
      module: "login modal"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_COMPLETED_FIELD", (data) => {
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "Field Complete",
      tag: undefined,
      gaEventLabel: get(data.payload, "fieldName", ""),
      module: "login modal"
    });
  });

  mediatorChannels.base.subscribe("FDR_USER_ATTEMPT_LOGIN", () => {
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "Login Attempt",
      tag: undefined,
      gaEventLabel: undefined,
      module: "login modal"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_RECONFIRM_LOCATION", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Login",
      gaEventAction: "Re-enable Location Services",
      tag: undefined,
      gaEventLabel: "login",
      module: "location services"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_SELECT_STATE_OPEN", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Login",
      gaEventAction: "Open State List",
      tag: undefined,
      gaEventLabel: "login",
      module: "location services"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_SELECT_STATE_CHOSEN", (data) => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Login",
      gaEventAction: `Select State - ${get(data, "payload.state")}`,
      tag: undefined,
      gaEventLabel: "login",
      module: "location services"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_CONFIRM_LOCATION", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Login",
      gaEventAction: "Confirm Selected State",
      tag: undefined,
      gaEventLabel: "login",
      module: "location services"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_NEED_HELP", () => {
    pushToDataLayer({
      event: "navigation",
      gaEventCategory: "Login",
      gaEventAction: "Message Us",
      tag: undefined,
      gaEventLabel: "login",
      module: "location services"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_RETURN_HOMEPAGE", (data) => {
    pushToDataLayer({
      event: "navigation",
      gaEventCategory: "Login",
      gaEventAction: "Return To Homepage",
      tag: undefined,
      gaEventLabel: `login - ${get(data, "payload.label")}`,
      module: "location services"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_CLOSE", (data) => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Login",
      gaEventAction: "navigated to",
      gaEventLabel: "Close Login",
      module: "location services",
      tag: undefined,
      destinationUrl: get(data, "payload.destinationUrl", "")
    });
  });

  mediatorChannels.base.subscribe("FDR_CLOSE_WELCOME_MODAL", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Site click",
      gaEventAction: "Close",
      gaEventLabel: "Homepage After Registration",
      module: "Registration"
    });
  });

  mediatorChannels.base.subscribe("FDR_OPEN_LOGIN_BRIDGE", () => {
    pushToDataLayer({
      event: "navigation",
      gaEventCategory: "navigation",
      gaEventAction: "navigated to",
      gaEventLabel: "Login Modal",
      module: "Login Modal",
      microApp: "non-Microapp"
    });
  });

  mediatorChannels.base.subscribe("FDR_OPEN_LOGIN_WALL", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Site click",
      gaEventAction: "Open",
      gaEventLabel: "Login Modal",
      module: "Login Modal",
      microApp: "non-Microapp"
    });
  });

  mediatorChannels.base.subscribe("FDR_CLOSE_LOGIN_WALL", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Site click",
      gaEventAction: "Close",
      gaEventLabel: "Login Modal",
      module: "Login Modal",
      microApp: "non-Microapp"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_WALL_SUCCESS", () => {
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "Login Success",
      gaEventLabel: undefined,
      module: "login modal"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_WALL_ERROR", (data) => {
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "Login Error",
      gaEventLabel: get(data, "payload.error", ""),
      module: "login modal"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_WALL_BUTTONS", (data) => {
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "click",
      gaEventLabel: get(data, "payload.button", ""),
      module: "login modal"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_WALL_SAW_LOCATION", () => {
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "saw",
      gaEventLabel: "location services",
      module: "login modal"
    });
  });

  mediatorChannels.base.subscribe("FDR_LOGIN_WALL_ENABLED_LOCATION", () => {
    pushToDataLayer({
      event: "login",
      gaEventCategory: "Login",
      gaEventAction: "enabled",
      gaEventLabel: "location services",
      module: "login modal"
    });
  });
};
